import { render, staticRenderFns } from "./MewAddressSelect.vue?vue&type=template&id=ecfabeba"
import script from "./MewAddressSelect.vue?vue&type=script&lang=js"
export * from "./MewAddressSelect.vue?vue&type=script&lang=js"
import style0 from "./MewAddressSelect.vue?vue&type=style&index=0&id=ecfabeba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports